<template>
  <div class="body">
    
    <div class="header">
      <el-form :model="accountForm" :inline="true">
        <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称">
              <el-input
                size="small"
                v-model="CustomerFindDTO.contactsName"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input
                size="small"
                v-model="CustomerFindDTO.telephone"
              ></el-input>
            </el-form-item>
  
 
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
          <el-button size="small" type="primary" @click="tohandleEdit">新增</el-button>
          <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
        </el-form-item>
      </el-form>
      <div class="pagination">

<el-pagination
  :current-page="currentPage"
  :page-sizes="[10, 30, 50, 100]"
  :page-size="pageSize"
  layout="total, sizes, prev, pager, next, jumper"
  :total="total"
  @size-change="handleSizeChange"
  @current-change="handleCurrentChange"
></el-pagination>
</div>
      <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增客户"
        width='40%'
        :visible.sync="drawer"
      >
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="客户名称" prop="name">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.contactsName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  </el-col>
  <el-col :span="12">
    <el-form-item  label="联系电话" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.telephone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
  </el-col>
</el-row>
<el-row :gutter="24">
        <el-col :span="12">
        <el-form-item  label="联系人" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.contacts"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="联系地址" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.address"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="24">
  <el-col :span="12">
        <el-form-item  label="折扣率" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.discountRate"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

      </el-col>
      <el-col :span="12">
        <el-form-item  label="客户分组" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.grouping"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="24">
  <el-col :span="12">
       
        <el-form-item  label="客户等级" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.grade"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
   
      </el-col>
      <el-col :span="12">
        <el-form-item  label="客户权限" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.customerAuthority"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item  label="备注" prop="remark">
          <el-input
          
            class="input-remark"
            size="small"
            v-model="accountForm.remarks"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <div style="display: flex">
        <el-upload
          class="upload-demo"
          action="#"
          accept="xlsx,xls"
          multiple
          :limit="1"
          :auto-upload="false"
          :with-credentials="false"
          :show-file-list="false"
        >
        <!-- <el-button size="small" type="primary">导入</el-button> -->
        </el-upload>
        <!-- <el-button
          size="small"
          style="margin-left: 10px"
          type="primary"
          @click="exportExcelData"
        >
          导出
        </el-button> -->
      </div>
    </div>
    <div style="margin: 10px">
      <el-table
        :data="conTract"
        stripe
        border
        style="width: 100%"
        :cell-style="styleBack"
        @selection-change="handleSelectionChange"
      >
      <el-table-column
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column
          prop="contactsName"
          align="center"
          label="客户名称"
        ></el-table-column>
        <el-table-column
          prop="telephone"
          align="center"
          label="联系电话"
        ></el-table-column>
        <el-table-column
          prop="contacts"
          align="center"
          label="联系人"
        ></el-table-column>
      
        <el-table-column
          prop="address"
          align="center"
          label="联系地址"
        ></el-table-column>
        <el-table-column
          prop="discountRate"
          align="center"
          label="折扣率"
        ></el-table-column>
        <el-table-column
          prop="grouping"
          align="center"
          label="客户分组"
        ></el-table-column>
        <!-- <el-table-column
          prop="grade"
          align="center"
          label="客户等级"
        ></el-table-column>
        <el-table-column
          prop="customerAuthority"
          align="center"
          label="客户权限"
        ></el-table-column> -->
        <el-table-column
          prop="remarks"
          align="center"
          label="备注"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="280">
        <template v-slot="{ row }">
          <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
        </template>
      </el-table-column>
      </el-table>
    </div>



    <el-dialog title="编辑客户" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false">
      <el-form
        ref="accountForm"
        :model="accountForm"
        label-width="100px"
        class="demo-accountForm"
      >
      <el-form-item label="客户名称" prop="outreachValue">
          <el-input v-model="accountForm.contactsName" ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="outreachValue">
          <el-input v-model="accountForm.telephone" ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="panelMaterial">
          <el-input v-model="accountForm.contacts" ></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="panelMaterial">
          <el-input v-model="accountForm.address" ></el-input>
        </el-form-item>
        <el-form-item label="折扣率" prop="panelMaterial">
          <el-input v-model="accountForm.discountRate" ></el-input>
        </el-form-item>
        <el-form-item label="客户分组" prop="panelMaterial">
          <el-input v-model="accountForm.grouping" ></el-input>
        </el-form-item>
        <el-form-item label="客户等级" prop="panelMaterial">
          <el-input v-model="accountForm.grade" ></el-input>
        </el-form-item>
        <el-form-item label="客户权限" prop="panelMaterial">
          <el-input v-model="accountForm.customerAuthority" ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="panelMaterial">
          <el-input v-model="accountForm.remarks" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editAccount()">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { selectCustomer,upDateCustomer,bathDeleteCustomer,addCustomer} from '@/api/order/customer'
export default {
  data() {
    return {
      cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()

                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
    direction: 'rtl',
      pageSize: 10,
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      ids: '',
      drawer: false,
      date: '',
      dialogVisible: false,
      conTract: [],
      directionStatus:[{
      value: '0',
      label: '顺时针'
    }, {
      value: '1',
      label: '逆时针'
    }],
      accountForm: {
        id:'',
        access:'',
        contactsName: '',
        telephone: '',
        contacts:'',
        address:'',
        discountRate:'',
        grouping:'',

        remarks: '',
        customerAuthority:'',
        grade: '',
       
      },
      CustomerFindDTO:{
          startTime: '',
          endTime: '',
          access: '',
          contactsName:'',
          telephone:''
      },
      searchForm: {
        startTime: '',
        secondStartTime: '',
        number: '',
        values: ''
      },
      DeleteDTO:{
        id:'',
      }
    }
  },
  

  mounted() {
      this.CustomerFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
   
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      getTableData() {
        selectCustomer(this.currentPage, this.pageSize, this.CustomerFindDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
        // 导入
        loadFile(file, fileList) {
        console.log(file, fileList)
        const formdata = new FormData()
        fileList.map((item) => {
          // fileList本来就是数组，就不用转为真数组了
          formdata.append('file', item.raw) // 将每一个文件图片都加进formdata
        })
        leadingIn(formdata).then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
            this.getTableData()
          }
        })
      },
  
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
              addCustomer(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleDelete() {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteCustomer(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
      deleteInfo(){
        bathDeleteCustomer(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      //修改
      editAccount() {
        upDateCustomer(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.CustomerFindDTO.startTime = e[0]
          this.CustomerFindDTO.endTime = e[1]
        } else if (!e) {
          this.CustomerFindDTO.startTime = ''
          this.CustomerFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },

        
      },
      
    
    
    }

</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px;
}
.body {
  overflow: auto;
}

.pagination {
  margin-top: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
}
.el-pagination ::v-deep.el-pagination__total {
  line-height: 36px;
}
</style>
